import {
  BodyScrollOptions,
  clearAllBodyScrollLocks,
  disableBodyScroll,
} from 'body-scroll-lock'
import { scrollLockIsParentOverflowing } from './isOverflowing'

export const fixedDisableBodyScroll = (
  targetElement: HTMLElement | Element,
  options?: BodyScrollOptions
): void => {
  // disable scroll
  disableBodyScroll(
    targetElement,
    options
      ? options
      : {
          reserveScrollBarGap: true,
          allowTouchMove: (e: Element) => {
            //fix for IOS & touch devices
            //put data scroll attribute on element that has overflow

            //check if element is overflowing aswell

            //if it is overflowing, allow touchmove

            //if it is not overflowing, don't allow touchmove
            if (scrollLockIsParentOverflowing(e)) return true
            return false
          },
        }
  )
  setScrollPaddingOnFixedElements()
}

export const fixedClearAllBodyScrollLocks = (): void => {
  // clear scroll
  clearAllBodyScrollLocks()
  setScrollPaddingOnFixedElements()
}

const setScrollPaddingOnFixedElements = () => {
  // find all elements that is fixed position
  const fixedElements: NodeListOf<HTMLElement> = document.querySelectorAll(
    '[data-fixed-scroll]'
  )
  // copy the padding-right value from the body
  const bodyPaddingRight = window
    .getComputedStyle(document.body)
    .getPropertyValue('padding-right')
  // apply to fixed elements
  fixedElements.forEach((element) => {
    element.style.paddingRight = bodyPaddingRight
  })
}
